import { render, staticRenderFns } from "./shoppingCart.vue?vue&type=template&id=40c8db26&scoped=true"
import script from "./shoppingCart.vue?vue&type=script&lang=js"
export * from "./shoppingCart.vue?vue&type=script&lang=js"
import style0 from "./shoppingCart.vue?vue&type=style&index=0&id=40c8db26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c8db26",
  null
  
)

export default component.exports